import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Outlet } from 'react-router-dom';
import Header from '../components/customer/Header';
import Footer from '../components/customer/Footer';

const CustomerLayout: React.FC = () => {
  const { currentLanguage, isRTL } = useLanguage();
  return (
    <div className="min-h-screen flex flex-col" dir={isRTL ? 'rtl' : 'ltr'} lang={currentLanguage}>
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default CustomerLayout;
